import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GlobalAlert.css';
import config from '../config';

const AlertDevice = ({ id, name, isConnected }) => {
  const navigate = useNavigate();
  const [imageError, setImageError] = useState(false);

  return (
    <div className="card">
      <div className="card-content">
        <div className="left-section">
          <div className="device-name">{name}</div>
          <div className="status-container">
            <div
              className="status-dot"
              style={{ backgroundColor: isConnected ? '#10b981' : '#ef4444' }}
            />
            <div className="status-text">
              {isConnected ? 'Connected' : 'Disconnected'}
            </div>
          </div>
        </div>
        <div className="right-section">
          <div className="device-image">
            {!imageError ? (
              <img
                src="/assets/ReceiverIcon.png"
                alt="Receiver"
                className="receiver-icon"
                onError={() => setImageError(true)}
              />
            ) : (
              <div className="receiver-icon" />
            )}
          </div>
        </div>
      </div>
      <button
        className="view-button"
        onClick={() => navigate(`/details/${id}`)}
      >
        <span className="view-button-text">View</span>
        <span className="view-button-arrow">›</span>
      </button>
    </div>
  );
};

const GlobalAlert = () => {
  const navigate = useNavigate();
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDevices = async () => {
      try {
        const response = await fetch(`${config.API_BASE_URL}/devices/summary`, {
          headers: {

          }
        });
        const data = await response.json();

        // Map backend data to UI structure
        const mappedDevices = data.map(d => {
          const lastSeen = new Date(d.last_seen + 'Z');
          const isConnected = (Date.now() - lastSeen.getTime()) < 30000; // Online if seen in last 30s
          return {
            id: d.device_id,
            name: d.device_id.replace(/^MM-/, ''), // Shorten name by removing MM-
            isConnected: isConnected,
            latest: d.latest // Store latest reading for potential UI use
          };
        });

        setDevices(mappedDevices);
      } catch (error) {
        console.error('Error fetching devices:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDevices();
    const interval = setInterval(fetchDevices, 2000); // Poll every 2s for RTI
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="safe-area">
      <div className="container">
        <div className="content-container">
          {/* Header Section */}
          <div className="header">
            {/* Logo */}
            <div className="logo-container">
              <img
                src="/assets/GlobalAlertzIconA.png"
                alt="Global Alertz Logo"
                className="logo-image"
              />
            </div>

            {/* Title */}
            <div className="title-container">
              <div className="title-main">GLOBAL ALERTZ</div>
              <div className="title-sub">MASTER MONITOR</div>
            </div>
          </div>

          <div className="web-actions">
            <button className="web-action-button" onClick={() => navigate('/alerts')}>
              🔔 System Alerts
            </button>
            <button className="web-action-button" onClick={() => navigate('/other-sensors')}>
              🛰️ Other Sensors
            </button>
            <button className="web-action-button" onClick={() => navigate('/rodent-stations')}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px', display: 'inline-block', verticalAlign: 'middle', marginTop: '-2px' }}>
                <path d="M12 22a8 8 0 0 0 8-8c0-5.5-4.5-10-8-10S4 8.5 4 14a8 8 0 0 0 8 8z"/>
                <path d="M16 14a4 4 0 0 0-8 0"/>
                <path d="M12 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/>
              </svg>
              Rodent Stations
            </button>
            <button className="web-action-button" onClick={() => navigate('/bedbug-traps')}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px', display: 'inline-block', verticalAlign: 'middle', marginTop: '-2px' }}>
                <rect width="8" height="14" x="8" y="5" rx="4"/>
                <path d="M18 8h2"/>
                <path d="M4 8h2"/>
                <path d="M18 12h2"/>
                <path d="M4 12h2"/>
                <path d="M17 16h3"/>
                <path d="M4 16h3"/>
                <path d="M8 3h8"/>
              </svg>
              Bedbug Traps
            </button>
          </div>

          {/* Devices List */}
          <div className="devices-container">
            {loading ? (
              <div style={{ color: 'white', textAlign: 'center', marginTop: '20px' }}>Loading devices...</div>
            ) : devices.length > 0 ? (
              devices.map((device) => (
                <AlertDevice
                  key={device.id}
                  id={device.id}
                  name={device.name}
                  isConnected={device.isConnected}
                />
              ))
            ) : (
              <div style={{ color: 'white', textAlign: 'center', marginTop: '20px' }}>No devices found.</div>
            )}
          </div>

          {/* Bottom spacer for navigation bar */}
          <div className="bottom-spacer" />
        </div>
      </div>
    </div>
  );
};

export default GlobalAlert;

